/* ===========================================================================
   assets/handlauf.js — Metallbau Odenthal
   Skizze der Wandhalter im Handlauf-Konfigurator      13.08.2026

   WARUM EINE EIGENE DATEI
   Stefan am 13.08.2026: "am besten machen wir eine Handlauf.js?" — ja, und
   zwar aus demselben Grund wie bei `mo-unternehmen.css` am selben Tag: Die
   Shopify-API ersetzt beim Schreiben IMMER die ganze Datei. In einer
   Sammeldatei mit zwoelf Bloecken loescht jede Sitzung mit veralteter Basis
   alles Neuere — ohne Merge, ohne Warnung. Genau das ist custom.css am
   13.08.2026 zweimal passiert (08:15 und 13:21, zusammen ueber 8 KB).

   Wer nur am Handlauf arbeitet, fasst jetzt nur diese Datei an.

   ⚠️ EINGEBUNDEN in layout/theme.liquid, direkt nach custom.js. Die Datei
   braucht custom.js NICHT — alle Masse stehen unten in MASSE. Sie steht nur
   deshalb dahinter, weil die Reihenfolge im <head> der Lesbarkeit dient.

   ⚠️ NICHT in custom.js zurueckkopieren. Laeuft der Block doppelt, zeichnen
   zwei Beobachter in dasselbe Element.
   =========================================================================== */

/* ===========================================================================
   Metallbau Odenthal - Handlauf: Halter zeigen        v1.0.0 - 13.08.2026

   WOZU
   Unter dem Laengenfeld des Handlaufs klaffte eine leere Flaeche (von Stefan
   zweimal markiert). Dort steht jetzt eine Prinzipskizze, die mitrechnet: sie
   zeigt das Rohr, die Wandhalter und die Masse dazwischen - und zwar fuer die
   Laenge, die der Kunde gerade eingetippt hat.

   Der fachliche Gewinn ist groesser als der optische: Die Halteranzahl ist die
   eine Angabe, die ein Kunde nicht beurteilen kann. Ein Marktvergleich am
   12.08.2026 (Koerting, HandlaufPRO, metallbau-onlineshop, handlauf-inox)
   zeigte, dass alle Anbieter sie deshalb VORBERECHNEN statt abzufragen. Genau
   das passiert hier - sichtbar, statt im Verborgenen.

   DIE REGEL steht in MO_KONFIG (Feld `halter`), nicht hier:
       rand      seitlicher Abstand der aeusseren Halter (Stefan: 100 mm)
       dreiAb    ab dieser Laenge drei Halter        (Stefan: 1500 mm)
       weiterJe  je weitere N mm ein Halter mehr     (abgeleitet: 1300 mm)
   Wer die Staffel aendert, fasst nur diese drei Zahlen an. `weiterJe` haelt den
   Achsabstand unter 1300 mm; Koerting empfiehlt fuer verschweisste Halter
   1200-1300 mm, fuer geschraubte 800-900 mm.

   WARUM SVG UND KEIN BILD
   Die Zeichnung muss sich bei jeder Eingabe aendern - ein Bild koennte das nur
   als Bildersatz je Stufe. SVG skaliert ausserdem verlustfrei und faerbt sich
   ueber die Akzentfarbe mit.

   WARUM EIN EIGENER BLOCK
   custom.js besteht aus mehreren getrennten IIFE. Dieser hier haengt an nichts
   ausser window.MO_KONFIG; faellt er aus, bleibt die Flaeche leer wie vorher.

   WANN NICHTS ERSCHEINT
   Ohne Eintrag in MO_KONFIG.halter passiert gar nichts - Fenstergitter, Balkon
   und Stange bleiben unberuehrt. Ohne eingetragene Laenge steht statt der
   Skizze ein Satz, der erklaert, was gleich kommt; sonst waere die Flaeche
   beim Seitenaufruf wieder leer.
   =========================================================================== */
(function () {
  var ID = 'mo-halter-skizze';

  /* ALLE MASSE DES HANDLAUFS — hier und nur hier. Jedes davon ist eine Zahl;
     wer die Staffel aendert, fasst nichts anderes an.

       rand          seitlicher Abstand der aeusseren Halter vom Rohrende
       dreiAb        ab dieser Laenge drei Halter statt zwei
       weiterJe      je weitere angefangene N mm ein Halter mehr
       wandAbstand   Rohrunterkante bis Wandflaeche
       platte        Breite der Wandrosette
       maxTeil       kein Fertigungsteil darf laenger sein (Stefan: 2 m)
       versatz       so weit weicht ein Stoss einem Halter aus
       steckTiefe    wie tief der Zapfen ins Nachbarrohr greift

     ⚠️ Der Schluessel ist die Config-UUID der Konfigurator-App. Steht eine
     Config nicht drin, passiert gar nichts — Fenstergitter, Balkon und Stange
     bleiben unberuehrt. Genau so war es vorher ueber MO_KONFIG geloest.
     Die Masse standen bis 13.08.2026 in custom.js; sie sind mit umgezogen,
     damit fuer eine Massaenderung niemand mehr die Sammeldatei anfassen muss. */
  var MASSE = {
    clscy95tcugw: { rand: 100, dreiAb: 1500, weiterJe: 1300, wandAbstand: 58, platte: 70, maxTeil: 2000, versatz: 40, steckTiefe: 50, minSkizze: 300 }
  };

  /* Die Config-UUID steht als id am Eltern-Element des Wrappers. Sie ist
     zugleich der Schalter: Nur was in MASSE steht, wird ueberhaupt bedient. */
  function uuid() {
    var wr = document.querySelector('.cl-po--wrapper');
    var wt = wr && wr.closest('[id]');
    return wt ? wt.id : null;
  }

  function konfig() {
    var id = uuid();
    return (id && MASSE[id]) || null;
  }

  /* Preisuebersicht in der Box "Ihre Auswahl" ausblenden.
     Beim Handlauf steht dort nur "Grundpreis (inkl. Maße)" — es gibt keine
     Zusatzoptionen zum Aufschluesseln. Stefan am 13.08.2026: "das brauchen wir
     auch nicht mehr". Menge daruber und Gesamtpreis darunter bleiben.
     ⚠️ An die UUID gebunden, nicht an `.cl-po--wrapper`: Sonst traefe die Regel
     jeden Konfigurator, und beim Fenstergitter ist die Aufschluesselung der
     ganze Sinn der Box. */
  function stil() {
    if (document.getElementById('mo-handlauf-stil')) return;
    var st = document.createElement('style');
    st.id = 'mo-handlauf-stil';
    /* ⚠️ An die ID der BOX gebunden, nicht an den Wrapper: Die Box haengt in
       `#mo-ablage`, also ausserhalb von `#<configUuid>` — ein Selektor ueber
       den Wrapper trifft sie nicht (am 13.08.2026 gemessen: display blieb
       block). Die ID hebt zugleich die Spezifitaet ueber die App-Regel
       `.cl-po--summary-pricing{display:block!important}`. */
    st.textContent = '#cl-po--summary-container .cl-po--summary-pricing,' +
                     '#cl-po--summary-container .cl-po--summary-price-divider' +
                     '{display:none!important}';
    /* ⚠️ Ans Ende des BODY, nicht in den <head>: Das App-CSS steht als
       <style> im Body. Bei gleicher Spezifitaet und beidseitigem !important
       gewinnt das spaetere Regelwerk. */
    (document.body || document.documentElement).appendChild(st);
  }

  /* Anzahl der Halter. Bewusst als Staffel und nicht ueber einen
     Hoechstabstand gerechnet: Stefans "ab 1500 drei" ist eine glatte Zahl, ein
     Hoechstabstand haette 1499/1500 nur mit einem krummen Wert getroffen. */
  function anzahl(L, h) {
    if (L < h.dreiAb) return 2;
    return 3 + Math.floor((L - h.dreiAb) / h.weiterJe);
  }

  function positionen(L, h) {
    var n = anzahl(L, h), von = h.rand, bis = L - h.rand, p = [];
    var schritt = (bis - von) / (n - 1);
    for (var i = 0; i < n; i++) p.push(Math.round(von + i * schritt));
    return p;
  }

  function svg(L, h) {
    var B = 640, mL = 40, mR = 40;
    var nutz = B - mL - mR, s = nutz / L;
    var xv = function (mm) { return (mL + mm * s).toFixed(1); };
    var yRohr = 62, rRohr = 9, yG = 26;

    /* Wandabstand MASSSTAEBLICH (Stefan, 13.08.2026: "die 58 mm realistisch
       machen, kuerzer, die sehen sehr lang aus").

       Gemessen wird von der Rohrunterkante bis zur Wandflaeche — die Rosette
       liegt darin. Bei 1260 mm ergibt das 26 px statt der bisherigen 79.

       ⚠️ Untergrenze 20 px: Bei einem 6000er Handlauf waeren 58 mm nur 5,4 px,
       der Halter waere ein Strich. Statt ihn dort zu verkleinern, wird die
       GANZE ZEICHNUNG flacher — Wand, Masskette und Zeichenhoehe wandern mit
       nach oben. So bleibt das Verhaeltnis bei kurzen und mittleren Laengen
       ehrlich und die Skizze bei langen trotzdem lesbar. */
    /* ⚠️ `s` gilt WAAGERECHT — dort soll das Rohr immer die volle Breite
       einnehmen, egal wie kurz es ist. Fuer alles SENKRECHTE und Kleinteilige
       braucht er einen Deckel: Bei 5 mm Laenge wird s rund 112, und 58 mm
       Wandabstand ergaeben 6496 px Zeichenhoehe. Genau so lief die Skizze am
       13.08.2026 senkrecht aus dem Bild.
       Der Deckel greift erst unterhalb von etwa 280 mm; alles darueber bleibt
       exakt wie vorher (600 mm: 54 px, unveraendert). */
    var sQuer = Math.min(s, 2);
    var tiefe = Math.max(20, (h.wandAbstand || 58) * sQuer);
    var yWand = yRohr + rRohr + tiefe;
    var yM = yWand + 36;
    var H = yM + 24;
    var pos = positionen(L, h), n = pos.length;
    var achs = Math.round((L - 2 * h.rand) / (n - 1));
    var t = [];

    t.push('<svg viewBox="0 0 ' + B + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="' +
           L + ' mm Handlauf mit ' + n + ' Wandhaltern">');
    /* Verlaeufe machen aus grauen Flaechen Metall. `moStahl` laeuft senkrecht
       (Rohr von oben gesehen), `moStahlQ` quer (Ausleger). */
    t.push('<defs><marker id="moPfeil" markerWidth="7" markerHeight="7" refX="3.5" refY="3.5" orient="auto">' +
           '<path d="M0,0 L7,3.5 L0,7 z" fill="#ea5b0b"/></marker>' +
           '<linearGradient id="moStahl" x1="0" y1="0" x2="0" y2="1">' +
           '<stop offset="0%" stop-color="#e8ebee"/><stop offset="38%" stop-color="#fbfcfd"/>' +
           '<stop offset="62%" stop-color="#c9ced4"/><stop offset="100%" stop-color="#aeb4bb"/></linearGradient>' +
           '<linearGradient id="moStahlQ" x1="0" y1="0" x2="1" y2="0">' +
           '<stop offset="0%" stop-color="#aeb4bb"/><stop offset="35%" stop-color="#fbfcfd"/>' +
           '<stop offset="70%" stop-color="#c9ced4"/><stop offset="100%" stop-color="#9aa1a9"/></linearGradient>' +
           '</defs>');

    /* Wand: erst die Flaeche, dann die Kante, dann die Schraffur. Eine blosse
       Linie liest sich als Boden — die Flaeche macht daraus eine Wand. */
    t.push('<rect x="' + (mL - 24) + '" y="' + yWand + '" width="' + (B - mL - mR + 48) +
           '" height="15" fill="#eef0f2"/>');
    t.push('<line x1="' + (mL - 24) + '" y1="' + yWand + '" x2="' + (B - mR + 24) + '" y2="' + yWand +
           '" stroke="#8b929a" stroke-width="1.5"/>');
    for (var hx = mL - 24; hx < B - mR + 24; hx += 11) {
      t.push('<line x1="' + hx + '" y1="' + (yWand + 2) + '" x2="' + (hx - 8) + '" y2="' + (yWand + 12) +
             '" stroke="#c7ccd2" stroke-width="1"/>');
    }

    /* Halter: Arm zur Wand plus Wandplatte */
    for (var i = 0; i < n; i++) {
      var x = xv(pos[i]);
      /* Ausleger als schmales Rechteck mit Querverlauf — ein Strich sieht aus
         wie eine Schnur, ein Rechteck wie ein Rohr. */
      t.push('<rect x="' + (x - 4.5) + '" y="' + (yRohr + rRohr) + '" width="9" height="' +
             (yWand - 9 - (yRohr + rRohr)) + '" rx="1" fill="url(#moStahlQ)" stroke="#8b929a" stroke-width="1"/>');
      /* Rosette: die Wandplatte von der Seite. MASSSTAEBLICH — die waagerechte
         Richtung der Skizze bildet Millimeter auf Pixel ab, hier stimmt das
         Verhaeltnis also wirklich. Untergrenze 10 px, damit sie bei einem
         6000er Handlauf (70 mm waeren dort 6,5 px) nicht zum Strich wird. */
      var pb = h.platte ? Math.max(10, h.platte * sQuer) : 23;
      t.push('<rect x="' + (x - pb / 2) + '" y="' + (yWand - 9) + '" width="' + pb + '" height="9" rx="3" ' +
             'fill="#b9bfc6" stroke="#8b929a" stroke-width="1"/>');
    }

    /* Wandabstand, senkrecht am linken Rand. Nur wenn in MO_KONFIG hinterlegt —
       ohne den Wert bleibt die Skizze wie zuvor.
       ⚠️ Der Ausleger ist NICHT massstaeblich: Die Skizze ist in der Laenge
       massstaeblich, 58 mm waeren dort je nach Handlauf 5 bis 26 px und der
       Halter kaum zu sehen. Technische Zeichnungen schreiben das Mass an,
       statt zu verkleinern — Stefans CAD-Zeichnung macht es genauso. */
    if (h.wandAbstand) {
      var xW = mL - 14;
      /* Bis zur WAND, nicht bis zur Rosette: Der Wandabstand ist der Abstand
         des Rohres von der Wandflaeche — die Rosette liegt dazwischen und
         gehoert mit ins Mass. Von Stefan am 13.08.2026 angemerkt. */
      var yO = yRohr + rRohr, yU = yWand;
      t.push('<line x1="' + xW + '" y1="' + yO + '" x2="' + xW + '" y2="' + yU +
             '" stroke="#ea5b0b" marker-start="url(#moPfeil)" marker-end="url(#moPfeil)"/>');
      /* Hilfslinien zu Rohr und Wandplatte, damit klar ist, was gemessen wird */
      t.push('<line x1="' + (xW - 3) + '" y1="' + yO + '" x2="' + (mL + 6) + '" y2="' + yO +
             '" stroke="#ea5b0b" stroke-width="0.7" opacity="0.55"/>');
      t.push('<line x1="' + (xW - 3) + '" y1="' + yU + '" x2="' + (mL + 6) + '" y2="' + yU +
             '" stroke="#ea5b0b" stroke-width="0.7" opacity="0.55"/>');
      /* Zahl gedreht, sonst passt sie nicht in den linken Rand */
      t.push('<text x="' + (xW - 5) + '" y="' + ((yO + yU) / 2) + '" text-anchor="middle" ' +
             'fill="#ea5b0b" font-family="system-ui,sans-serif" font-size="11" font-weight="600" ' +
             'transform="rotate(-90 ' + (xW - 5) + ',' + ((yO + yU) / 2) + ')">' +
             h.wandAbstand + '</text>');
    }

    /* Rohr */
    t.push('<rect x="' + mL + '" y="' + (yRohr - rRohr) + '" width="' + nutz + '" height="' + (2 * rRohr) +
           '" rx="' + rRohr + '" fill="url(#moStahl)" stroke="#8b929a" stroke-width="1"/>');
    /* Glanzkante: der eine Strich, der aus grauem Kunststoff Edelstahl macht. */
    t.push('<line x1="' + (mL + 8) + '" y1="' + (yRohr - rRohr + 5) + '" x2="' + (B - mR - 8) +
           '" y2="' + (yRohr - rRohr + 5) + '" stroke="#fff" stroke-width="1.6" opacity="0.85"/>');

    /* TRENNSTELLEN — kein Fertigungsteil laenger als `maxTeil`.
       Stefan am 13.08.2026: "Handlauf 6 meter 2 trennstellen 3 teile a 2m =
       so ist der plan kein teil laenger als 2 m".

       Also so WENIGE Stoesse wie moeglich und die Teile gleich lang: k Teile
       mit k = aufgerundet L/maxTeil, die Stoesse gleichmaessig verteilt. Bei
       6000 mm sind das genau zwei Stoesse und drei Teile a 2000 mm.

       ⚠️ Eine frühere Fassung schnappte jeden Stoss auf einen Wandhalter. Das
       hielt die 2-m-Grenze zwar ein, brauchte bei 6000 mm aber VIER Stoesse
       statt zwei — jeder Stoss ist Arbeit und eine Schwachstelle.

       AUSWEICHEN: Faellt ein Stoss auf einen Wandhalter, muesste dessen
       Schelle darueber greifen. Dann rueckt er um `versatz` zur Seite —
       bevorzugt nach hinten, sonst nach vorne, je nachdem was `maxTeil` noch
       einhaelt. Tritt bei 3 Haltern regelmaessig auf, weil dort der mittlere
       Halter und die einzige Trennstelle beide in der Mitte sitzen (2400 mm:
       Stoss auf 1240 statt 1200). Geht beides nicht auf, wird ein Teil mehr
       genommen — deshalb die Schleife ueber k.

       Durchgerechnet fuer alle 5901 Laengen von 100 bis 6000 mm: kein Teil
       ueber 2000 mm, kein Stoss naeher als 15 mm an einem Halter.

       Gezeichnet als zwei kurze senkrechte Striche AM ROHR, nicht als eine
       durchgehende Linie — eine durchgehende waere vom Halter darunter kaum zu
       unterscheiden. */
    var trenn = [];
    if (h.maxTeil && L > h.maxTeil) {
      var vs = (h.versatz || 40), NAH = 60;
      for (var k = Math.ceil(L / h.maxTeil); k <= 12; k++) {
        var vs2 = [], geht = true;
        for (var i2 = 1; i2 < k; i2++) {
          var x = Math.round(L * i2 / k), stoert = null;
          for (var q2 = 0; q2 < n; q2++) if (Math.abs(x - pos[q2]) < NAH) stoert = pos[q2];
          if (stoert !== null) {
            var vorher = vs2.length ? vs2[vs2.length - 1] : 0;
            var rechts = stoert + vs, links = stoert - vs;
            if (rechts - vorher <= h.maxTeil && (L * (i2 + 1) / k) - rechts <= h.maxTeil) x = rechts;
            else if (links - vorher > 0 && links - vorher <= h.maxTeil) x = links;
            else { geht = false; break; }
          }
          vs2.push(x);
        }
        if (!geht) continue;
        var tl = [], vv = 0;
        for (var z2 = 0; z2 < vs2.length; z2++) { tl.push(vs2[z2] - vv); vv = vs2[z2]; }
        tl.push(L - vv);
        if (Math.max.apply(null, tl) <= h.maxTeil) { trenn = vs2; break; }
      }
    }
    for (var w = 0; w < trenn.length; w++) {
      var xt = xv(trenn[w]);
      t.push('<line x1="' + xt + '" y1="' + (yRohr - rRohr) + '" x2="' + xt + '" y2="' + (yRohr - rRohr + 5) +
             '" stroke="#5b6470" stroke-width="1.6"/>');
      t.push('<line x1="' + xt + '" y1="' + (yRohr + rRohr - 5) + '" x2="' + xt + '" y2="' + (yRohr + rRohr) +
             '" stroke="#5b6470" stroke-width="1.6"/>');
      /* Der Steckzapfen greift in das Nachbarrohr — in einer Zeichnung ist das
         eine VERDECKTE KANTE und wird gestrichelt gezeichnet. Drei Linien: Ober-
         und Unterkante des Zapfens plus die Stirnkante. */
      if (h.steckTiefe) {
        var xs = parseFloat(xt) + h.steckTiefe * sQuer;
        t.push('<line x1="' + xt + '" y1="' + (yRohr - 3) + '" x2="' + xs + '" y2="' + (yRohr - 3) +
               '" stroke="#8b929a" stroke-width="1" stroke-dasharray="3 2"/>');
        t.push('<line x1="' + xt + '" y1="' + (yRohr + 3) + '" x2="' + xs + '" y2="' + (yRohr + 3) +
               '" stroke="#8b929a" stroke-width="1" stroke-dasharray="3 2"/>');
        t.push('<line x1="' + xs + '" y1="' + (yRohr - 3) + '" x2="' + xs + '" y2="' + (yRohr + 3) +
               '" stroke="#8b929a" stroke-width="1" stroke-dasharray="3 2"/>');
      }
    }

    /* Gesamtlaenge oben, nach Zeichnungsnorm: Masshilfslinien fuehren vom
       Bauteil zur Masslinie, die Masslinie laeuft DURCH, die Zahl steht
       darueber. Vorher stand die Zahl in einem weissen Kasten mitten auf der
       Linie und radierte sie dort weg — das findet sich in keiner technischen
       Zeichnung. */
    t.push('<line x1="' + mL + '" y1="' + (yG - 3) + '" x2="' + mL + '" y2="' + (yRohr - rRohr - 3) +
           '" stroke="#ea5b0b" stroke-width="0.7" opacity="0.5"/>');
    t.push('<line x1="' + (B - mR) + '" y1="' + (yG - 3) + '" x2="' + (B - mR) + '" y2="' + (yRohr - rRohr - 3) +
           '" stroke="#ea5b0b" stroke-width="0.7" opacity="0.5"/>');
    t.push('<line x1="' + mL + '" y1="' + yG + '" x2="' + (B - mR) + '" y2="' + yG +
           '" stroke="#ea5b0b" marker-start="url(#moPfeil)" marker-end="url(#moPfeil)"/>');
    t.push('<text x="' + (B / 2) + '" y="' + (yG - 5) + '" text-anchor="middle" fill="#ea5b0b" ' +
           'font-family="system-ui,sans-serif" font-size="12" font-weight="600">' + L + ' mm</text>');

    /* Masskette unten: Rand, Achsabstaende, Rand */
    function kette(a, b, text) {
      var x1 = xv(a), x2 = xv(b), mitte = (parseFloat(x1) + parseFloat(x2)) / 2;
      /* Masshilfslinien nach oben bis kurz unter die Wand */
      t.push('<line x1="' + x1 + '" y1="' + (yM - 3) + '" x2="' + x1 + '" y2="' + (yWand + 4) +
             '" stroke="#ea5b0b" stroke-width="0.7" opacity="0.5"/>');
      t.push('<line x1="' + x2 + '" y1="' + (yM - 3) + '" x2="' + x2 + '" y2="' + (yWand + 4) +
             '" stroke="#ea5b0b" stroke-width="0.7" opacity="0.5"/>');
      t.push('<line x1="' + x1 + '" y1="' + yM + '" x2="' + x2 + '" y2="' + yM +
             '" stroke="#ea5b0b" marker-start="url(#moPfeil)" marker-end="url(#moPfeil)"/>');
      t.push('<text x="' + mitte + '" y="' + (yM - 5) + '" text-anchor="middle" fill="#ea5b0b" ' +
             'font-family="system-ui,sans-serif" font-size="12" font-weight="600">' + text + '</text>');
    }
    kette(0, h.rand, h.rand);
    for (var k = 0; k < n - 1; k++) kette(pos[k], pos[k + 1], achs);
    kette(L - h.rand, L, h.rand);

    t.push('</svg>');
    return { markup: t.join(''), anzahl: n, achs: achs, trenn: trenn };
  }

  function feld() {
    return document.querySelector('.cl-po--option[data-option="Maße"] .cl-po--dimension-item input[type="text"]');
  }

  function zeichnen() {
    var h = konfig();
    if (!h) return;                                   /* nicht dieser Konfigurator */
    stil();
    var opt = document.querySelector('.cl-po--option[data-option="Maße"]');
    if (!opt) return;

    var kasten = document.getElementById(ID);
    if (!kasten) {
      kasten = document.createElement('div');
      kasten.id = ID;
      kasten.className = 'mo-halter-skizze';
      opt.appendChild(kasten);
    } else if (kasten.parentNode !== opt) {
      opt.appendChild(kasten);                        /* die App hat neu gerendert */
    }

    var f = feld();
    var L = f ? parseInt(String(f.value).replace(/[^\d]/g, ''), 10) : NaN;

    if (!(L > 0)) {
      if (kasten.getAttribute('data-mo-stand') !== 'leer') {
        kasten.setAttribute('data-mo-stand', 'leer');
        kasten.innerHTML = '<p class="mo-halter-hinweis">Tragen Sie die Länge ein – wir zeigen Ihnen sofort, ' +
                           'wie viele Wandhalter Sie brauchen und wo sie sitzen.</p>';
      }
      return;
    }
    /* Zu kurz fuer eine sinnvolle Zeichnung. Bei 5 mm saessen die beiden
       Wandhalter mit ihren je 100 mm Randabstand ausserhalb des Rohres, und die
       Bemassung waere ein Knaeuel. Die App zeigt in diesem Fall ohnehin schon
       "Länge mind. 100 mm" — ein zweiter roter Hinweis hilft niemandem, ein
       Satz mit der Aussicht dagegen schon. */
    if (L < (h.minSkizze || 300)) {
      if (kasten.getAttribute('data-mo-stand') !== 'kurz') {
        kasten.setAttribute('data-mo-stand', 'kurz');
        kasten.innerHTML = '<p class="mo-halter-hinweis">Ab ' + (h.minSkizze || 300) +
                           ' mm zeigen wir Ihnen, wie viele Wandhalter Sie brauchen ' +
                           'und wo sie sitzen.</p>';
      }
      return;
    }
    if (kasten.getAttribute('data-mo-stand') === String(L)) return;   /* nichts Neues */

    var z = svg(L, h);
    kasten.setAttribute('data-mo-stand', String(L));
    /* Der Hinweis auf die Trennstelle steht DIREKT unter der Skizze, nicht in
       den Produktdetails weiter unten: Hier ist der Kunde gerade beim Mass und
       sieht die Stelle in der Zeichnung darueber. */
    var trennText = '';
    if (z.trenn && z.trenn.length) {
      var k = z.trenn.length;
      /* Aufzaehlung mit "und" vor dem letzten Wert — "1300, 2460, 3620 und
         4780 mm" liest sich wie ein Satz, "1300, 2460, 3620, 4780" wie eine
         Datenzeile. */
      var liste = k === 1 ? String(z.trenn[0])
                          : z.trenn.slice(0, -1).join(', ') + ' und ' + z.trenn[k - 1];
      var teilwort = ['', '', 'zweiteilig', 'dreiteilig', 'vierteilig', 'fünfteilig', 'sechsteilig'][k + 1] ||
                     ('in ' + (k + 1) + ' Teilen');
      trennText = ' <br><strong>' + (k === 1 ? 'Mit Trennstelle:' : 'Mit ' + k + ' Trennstellen:') +
                  '</strong> Kein Teil darf länger als ' + h.maxTeil + ' mm sein, der Handlauf wird deshalb ' +
                  teilwort + ' gefertigt. Die ' + (k === 1 ? 'Stoßstelle liegt' : 'Stoßstellen liegen') +
                  ' bei ' + liste + ' mm. Die Teile werden gesteckt — ' +
                  'ein Zapfen greift ' + (h.steckTiefe || 50) + ' mm in das Nachbarrohr.';
    }
    kasten.innerHTML = z.markup +
      '<p class="mo-halter-text"><strong>' + z.anzahl + ' Wandhalter</strong> im Abstand von ' +
      z.achs + ' mm, außen jeweils ' + h.rand + ' mm vom Ende. Sind im Preis enthalten.' +
      trennText + '</p>';
  }

  function start() {
    zeichnen();
    /* Eingaben: ein einziger delegierter Zuhoerer statt eines pro Feld - die App
       tauscht ihre Felder beim Neurendern aus. */
    document.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('.cl-po--dimension-item input')) zeichnen();
    }, true);
    document.addEventListener('change', zeichnen, true);

    /* Beobachter statt Takt: die App baut die Optionsliste bei jeder
       Preisberechnung neu auf, dabei verschwindet der Kasten. Ein Intervall
       waere billiger zu schreiben, laeuft aber ewig; siehe den Block
       "Schrittfuehrung", wo genau das schon einmal Aerger gemacht hat.

       ⚠️ Der Beobachter haengt am BODY, nicht am Konfigurator. Beim ersten
       Anlauf war es .cl-po--wrapper — den gibt es zu diesem Zeitpunkt aber noch
       gar nicht: LPO rendert erst nach dem Laden. Ergebnis am 13.08.2026
       gemessen: MO_KONFIG stand, Wrapper und Option standen, der Kasten fehlte
       trotzdem — weil `start()` einmal ins Leere lief und mangels Wrapper nie
       ein Beobachter angehaengt wurde, der es haette nachholen koennen. */
    if (typeof MutationObserver !== 'undefined') {
      var geplant = false;
      new MutationObserver(function () {
        if (geplant) return;
        geplant = true;
        setTimeout(function () { geplant = false; zeichnen(); }, 60);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
